module.exports = __webpack_public_path__ + "static/media/deletei.bf3a8af7.svg";